import type {CSSProperties} from 'react';
import type {ApiWork} from '@/types/api';
import {highlightUrl, isTemplateImage} from '@/lib/demo/media';

export function WorkGallery({works}: {works: ApiWork[]}) {
  if (works.length === 0) return null;
  return (
    <div className="flex flex-col gap-5 lg:grid lg:grid-cols-2 lg:gap-4">
      {works.map((work) => (
        <figure key={work.id} className="m-0 flex flex-col gap-2">
          <div
            className={`panel overflow-hidden rounded-3xl${isTemplateImage(work.imageUrl) ? ' tpl-hl' : ''}`}
            style={isTemplateImage(work.imageUrl) ? ({'--hl': `url(${highlightUrl(work.imageUrl)})`} as CSSProperties) : undefined}
          >
            <img
              src={work.imageUrl}
              alt={work.caption ?? 'Пример работы'}
              loading="lazy"
              className="block aspect-[8/5] w-full object-cover lg:aspect-[3/2]"
            />
          </div>
          {work.caption ? <figcaption className="text-[15px] text-muted-foreground">{work.caption}</figcaption> : null}
        </figure>
      ))}
    </div>
  );
}
